export default {
    COMUM: 1,
    ESPECIAL: 2,
    ESPECIAL_AMARELA: 3,
    ESPECIAL_AZUL: 4,
}